import { createContext } from 'preact';
import { IRootDataset, ISessionState, ISharpenData } from './widget';

export interface IWidgetContext {
  session?: ISessionState;
  rootData?: IRootDataset;
  sharpenData?: ISharpenData;
}

export const WidgetContext = createContext<IWidgetContext>({});
